import findKeyPathByRowId from "./findKeyPathByRowId";

export default function getKeyPathByRowId(statement: Statement, rowId: string): KeyPath {
    const statementRowKeyPath = findKeyPathByRowId(statement, rowId);
    if (!statementRowKeyPath) {
        throw new Error('Statement row index not found for row ' + rowId + ' of statement ' + statement.id);
    }
    return statementRowKeyPath;
}
